import { render, staticRenderFns } from "./Numberinput.vue?vue&type=template&id=5ee0c4fb&"
import script from "./Numberinput.vue?vue&type=script&lang=js&"
export * from "./Numberinput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports